



















import { Component, Vue } from 'vue-property-decorator';
import FakeAsset from '@/components/tools/dialogscanner/FakeAsset.vue';
import CustomDialog from '@/components/tools/CustomDialog.vue';

@Component({
    components: {
        FakeAsset,
        CustomDialog
    }
})
export default class FakeProductPage extends Vue {
    public show = true;
    public contentHeight = '300px';

    public actionClicked() {
        this.$router.push({name: 'landing'});
    }

    get headerTitle() {
        return 'Verification failed';
    }

    get merchant() {
        return this.$route.query.merchant;
    }

}
